import {} from "../port/index.js";
import {} from "../rule/index.js";
import {} from "./Mod.js";
import { findRuleByNodes } from "./findRuleByNodes.js";
export function findRuleByPorts(mod, first, second) {
    if (first.isPrincipal && second.isPrincipal) {
        return findRuleByNodes(mod, first.node, second.node);
    }
}
//# sourceMappingURL=findRuleByPorts.js.map